/**
 * Provider-agnostic auth contract. The rest of the app only uses useAuth();
 * it never knows whether MSAL or dev personas are behind it.
 */

import { createContext, useContext } from "react";

export interface AuthContextValue {
  isAuthenticated: boolean;
  /** True while the provider is resolving (MSAL redirect handling, dev token fetch). */
  isLoading: boolean;
  /** Display name from the identity provider (backend profile may differ). */
  accountName: string | null;
  login: () => Promise<void>;
  logout: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextValue | null>(null);

export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within an auth provider");
  return ctx;
}
